export const getters = {
  questionsByKey: ({ lists = {}, questions } = { lists: {} }) =>
    Object.entries(lists).reduce(
      (acc, [key, ids]) => ({ ...acc, [key]: ids.map((id) => questions[id]) }),
      {}
    )
}

export default getters
